<template>
	<div>
		<div v-if="loading">
			<div class="row">
				<div class="col-12 mb-8">
					<div class="skeleton midnight h20 w200"></div>
				</div>
			</div>

			<div class="mt-8 row">
				<div class="col-12">
					<div class="skeleton midnight h20 w200 mb-4"></div>
				</div>

				<div class="col-12 col-lg-6" v-for="x in 4" :key="x">
					<div class="card mb-8">
						<div class="card-header">
							<div class="skeleton midnight h20 w200"></div>
						</div>
						<div class="card-body">
							<div class="form-group clear-left">
								<div class="skeleton midnight h20 w200"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-else-if="error">
			<div class="card" style="width: 18rem; margin: 40px auto 0;">
				<div class="card-body text-center">
					<b-icon
						icon="x-circle-fill"
						class="text-danger mb-2"
						style="font-size: 1.5rem"
					/>
					<h5 class="card-title capitalise">{{ $t("error") }}</h5>
					<p class="card-text">
						{{ $t("problem-loading-test") }}
					</p>
					<button class="btn btn-primary" @click="getTest">
						Load test
					</button>
				</div>
			</div>
		</div>

		<div v-else-if="saved">
			<div class="row">
				<div class="col-12 mb-4">
					<div class="card" style="width: 18rem; margin: 40px auto 0;">
						<div class="card-body text-center">
							<b-icon
								icon="check-circle-fill"
								class="text-success mb-2"
								style="font-size: 1.5rem"
							/>
							<h5 class="card-title">{{ $t("test-saved") }}</h5>
							<p class="card-text">
								{{ $t("test-saved-successfully") }}
							</p>
							<router-link to="/tests">
								<button class="btn btn-primary">{{ $t("done") }}</button>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-else-if="test">
			<div class="row">
				<div class="col-12 mb-4">
					<div class="float-sm-left">
						<h1 class="mb-0">
							{{ test.Code }}:
							{{ test.Name }}
						</h1>

						<p class="mb-0">
							{{ $t('student-colon') }}
							{{ test.student_displayname }}
						</p>
						<p class="mb-0">
							{{ $t('teacher-colon') }}
							{{ test.teacher_displayname }}
						</p>

						<p class="mb-0">
							<b-icon icon="calendar" class="mr-1" />
							{{ $t('created-colon') }}
							{{ $datetime.getLocaleStringFromTimeStamp(test.DateAdded) }}
						</p>

						<p class="mb-0" v-if="!canEdit">
							<b-icon icon="clock" class="mr-1" />
							{{ $t('date-taken-colon') }}
							{{ $datetime.getLocaleStringFromTimeStamp(test.DateTaken) }}
						</p>

						<p class="mb-0 " v-if="test.TreatmentSessionID">
							<!--<i class="custom-icon icon-tooth mr-1"></i>-->
							<b-icon icon="card-checklist" class="mr-1" />
							<strong>
								{{ $t('treatment-session-colon') }}
								{{ test.TreatmentSessionID }}
							</strong>
							<router-link :to="`/clinical/treatmentsession/${test.TreatmentSessionID}`" class="btn btn-sm btn-primary">
								{{ $t('view') }}
							</router-link>
						</p>
					</div>

					<div class="float-right">
						<button
							class="btn btn-primary mr-2"
							@click="saveTest"
							v-if="canEdit"
						>
							{{ $t("save-test") }}
						</button>

						<button
							class="btn btn-outline-secondary"
							v-if="isTeacher && test.HasPassed == -1"
							@click="abandonTest"
						>
							{{  $t('abandon') }}
						</button>
					</div>

				</div>
			</div>

			<div class="form-group" v-if="canEdit">
				<label>{{ $t("date-time") }}</label>
				<input
					type="datetime-local"
					v-model="test.datetime"
					class="form-control"
					style="max-width:250px"
				/>
			</div>

			<TestMarkingForm
				:test="test"
				:readonly="!canEdit"
                :submittercanedittheirfields="submittercanedittheirfields"
                :custompassfail="custompassfail"
				v-if="test"
			>
			</TestMarkingForm>

		</div>
	</div>
</template>

<script>
import TestMarkingForm from "src/components/TestMarkingForm.vue";
export default {
	components: {
		TestMarkingForm
	},
	data: function() {
		return {
			test: null,
			error: false,
			loading: false,
			saved: false,
			pageNum: 1,
			abandonAfterCallback: false,
            submittercanedittheirfields: false,
            custompassfail: []
		};
	},
	mounted() {
		this.getTest();
	},
	methods: {
		getTest: function() {
			this.loading = true;
			this.error = false;

			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/session/load`, {
				data: {
					id: this.$route.params.competencytestid
				}
			})
			.then(res => {
				if (res.status === "SUCCESS") {
					this.test = res.competencytestsession;
                    this.custompassfail = res.custompassfail;
					this.loading = false;
                    this.submittercanedittheirfields = res.submittercanedittheirfields
					// Fix the date for the UI
					if(this.test.DateTaken) {
						this.test.datetime = this.$datetime.getDateTimeFieldValueFromTimestamp(
							this.test.DateTaken
						);
					} else {
						this.test.datetime = this.$datetime.getDateTimeLocalFieldNowValue();
					}
				} else {
					this.loading = false;
					this.error = true;
				}
			})
			.catch(err => {
				this.$log.error.call(this, err);
				this.loading = false;
				this.error = true;
			});
		},
		saveTest() {

			this.test.DateTaken = this.$datetime.getTimeStampFromDateTimeField(
				this.test.datetime
			);

			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/session/save`, {
				method: "post",
				data: {
					competencytestsession: this.test
				}
			})
				.then(res => {
					if (res.status === "SUCCESS") {
						this.saved = true;
					} else {
						this.error = true;
					}
				})
				.catch(err => {
					this.error = err;
				});
		},
		abandonTest: function() {
			var self = this;

			this.$store.commit("openDialog", {
				title: this.$t("abandon-test-question"),
				content: this.$t("are-you-sure-abandon-test-question"),
				cancelBtn: true,
				cancelBtnText: this.$t("no"),
				confirmBtnText: this.$t("yes"),
				confirmCallBack: async function() {
					const res = await self.$cfetch(`${self.$settings.APIBaseURL}/competencytests/session/save`, {
						method: "post",
						data: {
							competencytestsession: {
								...self.test,
								Abandoned: true,
							}
						}
					})
					if (res.status === "SUCCESS") {
						self.saved = true;
					} else {
						self.error = true;
					}
				}
			});
		},
		togglePassed(pass) {
			this.test.HasPassed = pass;
		}
	},
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		},
		canEdit: function() {
			if(this.isTeacher){
				return true;
			}
			/*
			can't do this!
			if(this.test.form && this.test.HasPassed === -1){
				return true;
			}
			*/
			return false;
		}
	}
};
</script>
